"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgQuoteSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M22.91 2a1.09 1.09 0 110 2.182c-.13 0-.41.026-.787.11-.643.143-1.285.4-1.882.798-1.542 1.028-2.547 2.813-2.749 5.637h5.417c.603 0 1.091.489 1.091 1.091v8.727a1.09 1.09 0 01-1.09 1.091h-6.546a1.09 1.09 0 01-1.091-1.09v-8.728c0-4.172 1.4-6.971 3.758-8.544C20.466 2.317 21.895 2 22.91 2zM7.635 2a1.09 1.09 0 010 2.182c-.13 0-.409.026-.786.11-.642.143-1.285.4-1.881.798-1.542 1.028-2.548 2.813-2.75 5.637h5.417c.603 0 1.091.489 1.091 1.091v8.727a1.09 1.09 0 01-1.09 1.091H1.09A1.09 1.09 0 010 20.546v-8.728c0-4.172 1.4-6.971 3.759-8.544C5.194 2.317 6.622 2 7.636 2z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgQuoteSolid;
exports.default = _default;